import React from 'react';
import { Row, Card, CardImg, CardBody, CardTitle, CardText, Button, Col, Badge, CardFooter } from 'reactstrap';
import { Icon } from 'src/components/Component';
import Head from 'src/layout/head/Head';
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import HasFeature from "src/utils/has-feature";
import HasRole from "src/utils/has-role";

import WebhooksLogo from './images/webhooks.png'
import NuapayLogo from './images/nuapay.png'
import NuveiLogo from './images/nuvei.png'
import TotalProcessingLogo from './images/total-processing.png'
import StripeLogo from './images/stripe.png'
import APILogo from './images/api.png'
import OpenBankingLogo from './images/open-banking.png'
import XeroLogo from './images/xero.png';
import ZapierLogo from './images/zapier.png';
import SlackLogo from './images/slack.png';
import QuickbooksLogo from './images/quickbooks.svg';
import PlanetLogo from './images/planet.svg';
import BrowserWindows from './images/browser-windows.png';

const Integrations = ({ ...props }) => {
  const { organisation: { organisations, features, integrations }, account: { account } } = useSelector((state) => state);

  return (
    <React.Fragment>

      <Head title="Integrations" />

      <Row className="mb-3 ml-1 mr-1 mt-2">
        <h2 className="nk-block-title page-title text-primary">Payment <span className="fw-normal">Integrations</span></h2>
      </Row>

      <Row>
        <Col className="ml-1 mr-1">
          <Row>

            <Col md="12" lg="4" xl="3">
              <Card className="card-bordered integration-item">
                <div className='image-container'>
                  <div className='badges'>
                    <Badge color="white">Open Banking Payments</Badge>
                  </div>
                  <CardImg top src={NuapayLogo} alt="Nuapay logo" />
                </div>
                <CardBody className="card-inner pt-0">
                  <CardTitle tag="h5" className='text-xl text-purple-900 font-bold'>Nuapay</CardTitle>

                  <CardText>Take payments using open banking</CardText>
                </CardBody>
                <CardFooter>
                  {organisations.map((org) => org.id).includes('X1234') && (
                    <React.Fragment>
                      {integrations?.payments?.indexOf('NUAPAY') > -1 && (
                        <Button className='btn-primary btn-block w-100 text-center'>
                          <Icon name="setting" />Manage
                        </Button>
                      )}
                      {integrations?.payments?.indexOf('NUAPAY') === -1 && (
                        <Button className='btn-green btn-block w-100 text-center'>
                          <Icon name="setting" />Add
                        </Button>
                      )}
                    </React.Fragment>
                  )}
                  {!organisations.map((org) => org.id).includes('X1234') && (
                    <Button className='disabled:bg-red-800 disabled:border-red-800 btn-block w-100 text-center' disabled>
                      You do not have access to this feature
                    </Button>
                  )}
                </CardFooter>
              </Card>
            </Col>

            <Col md="12" lg="4" xl="3">
              <Card className="card-bordered integration-item">
                <div className='image-container'>
                  <div className='badges'>
                    <Badge color="white">Card Processing</Badge>
                  </div>
                  <CardImg top src={NuveiLogo} alt="total processing logo" />
                </div>
                <CardBody className="card-inner pt-0">
                  <CardTitle tag="h5" className='text-xl text-purple-900 font-bold'>Nuvei</CardTitle>
                  <CardText>Take payments via credit/debit card</CardText>
                </CardBody>
                <CardFooter>
                  {organisations.map((org) => org.id).includes('X1234') && (
                    <React.Fragment>
                      {integrations?.payments?.indexOf('NUVEI') > -1 && (
                        <Button className='btn-primary btn-block w-100 text-center'>
                          <Icon name="setting" />Manage
                        </Button>
                      )}
                      {integrations?.payments?.indexOf('NUVEI') === -1 && (
                        <Button className='btn-green btn-block w-100 text-center'>
                          <Icon name="setting" />Add
                        </Button>
                      )}
                    </React.Fragment>
                  )}
                  {!organisations.map((org) => org.id).includes('X1234') && (
                    <Button className='disabled:bg-red-800 disabled:border-red-800 btn-block w-100 text-center' disabled>
                      You do not have access to this feature
                    </Button>
                  )}
                </CardFooter>
              </Card>
            </Col>

            <Col md="12" lg="4" xl="3">

              <Card className="card-bordered integration-item">
                <div className='image-container'>
                  <div className='badges'>
                    <Badge color="white">Card Processing</Badge>
                  </div>
                  <CardImg top src={PlanetLogo} alt="total processing logo" />
                </div>
                <CardBody className="card-inner pt-0">
                  <CardTitle CardTitle tag="h5" className='text-xl text-purple-900 font-bold'>Planet</CardTitle>
                  <CardText>Take payments via credit/debit card</CardText>
                </CardBody>
                <CardFooter>
                  <Button className='btn-green btn-block w-100 text-center' disabled>
                    Coming Soon
                  </Button>
                </CardFooter>
              </Card>
            </Col>

            <Col md="12" lg="4" xl="3">

              <Card className="card-bordered integration-item">
                <div className='image-container'>
                  <div className='badges'>
                    <Badge color="white">Card Processing</Badge>
                  </div>
                  <CardImg top src={StripeLogo} alt="total processing logo" />
                </div>
                <CardBody className="card-inner pt-0">
                  <CardTitle CardTitle tag="h5" className='text-xl text-purple-900 font-bold'>Stripe</CardTitle>
                  <CardText>Take payments via credit/debit card</CardText>
                </CardBody>
                <CardFooter>
                  <Button className='btn-green btn-block w-100 text-center' disabled>
                    Coming Soon
                  </Button>
                </CardFooter>
              </Card>
            </Col>

            <Col md="12" lg="4" xl="3">
              <Card className="card-bordered integration-item">
                <div className='image-container'>
                  <div className='badges'>
                    <Badge color="white">Card Processing</Badge>
                  </div>
                  <CardImg top src={TotalProcessingLogo} alt="stripe logo" />
                </div>
                <CardBody className="card-inner pt-0">
                  <CardTitle CardTitle tag="h5" className='text-xl text-purple-900 font-bold'>Total Processing</CardTitle>
                  <CardText>Take payments via credit/debit card</CardText>
                </CardBody>
                <CardFooter>
                  {organisations.map((org) => org.id).includes('X1234') && (
                    <React.Fragment>
                      {integrations?.payments?.indexOf('TOTAL_PROCESSING') > -1 && (
                        <Button className='btn-primary btn-block w-100 text-center'>
                          <Icon name="setting" />Manage
                        </Button>
                      )}
                      {integrations?.payments?.indexOf('TOTAL_PROCESSING') === -1 && (
                        <Button className='btn-green btn-block w-100 text-center'>
                          <Icon name="setting" />Add
                        </Button>
                      )}
                    </React.Fragment>
                  )}
                  {!organisations.map((org) => org.id).includes('X1234') && (
                    <Button className='disabled:bg-red-800 disabled:border-red-800 btn-block w-100 text-center' disabled>
                      You do not have access to this feature
                    </Button>
                  )}
                </CardFooter>
              </Card>
            </Col>

          </Row>

        </Col>
      </Row>

      <Row className="mb-3 ml-1 mr-1 mt-5">
        <h2 className="nk-block-title page-title text-primary">Accounting & Finance <span className="fw-normal">Integrations</span></h2>
      </Row>

      <Row>
        <Col className="ml-1 mr-1">
          <Row>

            <Col md="12" lg="4" xl="3">
              <Card className="card-bordered integration-item">
                <div className='image-container'>
                  <CardImg top src={OpenBankingLogo} alt="Open Banking logo" />
                </div>
                <CardBody className="card-inner pt-0">
                  <CardTitle tag="h5" className='text-xl text-purple-900 font-bold'>Banking Integration</CardTitle>
                  <CardText>Link your bank account, for easy end to end reconcilliation of payments</CardText>
                </CardBody>
                <CardFooter>
                  {HasFeature(features, ['aisp']) && HasRole(account, ['open-banking:manage']) && (
                    <Link to='/organisation/bank'>
                      <Button className='btn-primary btn-block w-100 text-center'>
                        <Icon name="setting" />Manage
                      </Button>
                    </Link>
                  )}
                  {(!HasFeature(features, ['aisp']) || !HasRole(account, ['open-banking:manage'])) && (
                    <Button className='disabled:bg-red-800 disabled:border-red-800 btn-block w-100 text-center' disabled>
                      You do not have access to this feature
                    </Button>
                  )}
                </CardFooter>
              </Card>
            </Col>

            <Col md="12" lg="4" xl="3">
              <Card className="card-bordered integration-item">
                <div className='image-container'>
                  <CardImg top src={QuickbooksLogo} alt="Open Banking logo" />
                </div>
                <CardBody className="card-inner pt-0">
                  <CardTitle tag="h5" className='text-xl text-purple-900 font-bold'>Quickbooks</CardTitle>
                  <CardText>Reconcile disbursements to Quickbooks from your Felloh account</CardText>
                </CardBody>
                <CardFooter>
                  <Button className='btn-green btn-block w-100 text-center' disabled>
                    Coming Soon
                  </Button>
                </CardFooter>
              </Card>
            </Col>

            <Col md="12" lg="4" xl="3">
              <Card className="card-bordered integration-item">
                <div className='image-container'>
                  <CardImg top src={XeroLogo} alt="Open Banking logo" />
                </div>
                <CardBody className="card-inner pt-0">
                  <CardTitle tag="h5" className='text-xl text-purple-900 font-bold'>Xero</CardTitle>
                  <CardText>Reconcile disbursements to Xero from your Felloh account</CardText>
                </CardBody>
                <CardFooter>
                  <Button className='btn-green btn-block w-100 text-center' disabled>
                    Coming Soon
                  </Button>
                </CardFooter>
              </Card>
            </Col>

          </Row>

        </Col>

      </Row>

      <Row className="mb-3 ml-1 mr-1 mt-5">
        <h2 className="nk-block-title page-title text-primary">Other <span className="fw-normal">Integrations</span></h2>
      </Row>

      <Row>
        <Col className="ml-1 mr-1">
          <Row className='d-flex'>

            <Col md="12" lg="3" xl="3" className='d-flex'>
              <Card className="card-bordered integration-item flex-fill">
                <div className='image-container'>
                  <CardImg top src={APILogo} alt="API logo" />
                </div>
                <CardBody className="card-inner pt-0">
                  <CardTitle tag="h5" className='text-xl text-purple-900 font-bold'>Felloh API</CardTitle>

                  <CardText>Programatically access the Felloh API's</CardText>

                </CardBody>
                <CardFooter>
                  {HasRole(account, ['developers:manage:keys']) && HasFeature(features, ['developers']) && (
                    <Row>

                      <Col sm="12" lg="6">
                        <Link to='/developers'>
                          <Button className='btn-primary btn-block w-100 text-center'>
                            <Icon name="setting" />Manage
                          </Button>
                        </Link>
                      </Col>

                      <Col sm="12" lg="6">
                        <a href='https://developers.felloh.com' target='__blank'>
                          <Button className='btn-secondary btn-block w-100 text-center'>
                            <Icon name="setting" />Documentation
                          </Button>
                        </a>
                      </Col>

                    </Row>
                  )}

                  {(!HasFeature(features, ['developers']) || !HasRole(account, ['developers:manage:keys'])) && (
                    <Button className='disabled:bg-red-800 disabled:border-red-800 btn-block w-100 text-center' disabled>
                      You do not have access to this feature
                    </Button>
                  )}
                </CardFooter>
              </Card>
            </Col>


            <Col md="12" lg="3" xl="3" className='d-flex'>
              <Card className="card-bordered integration-item flex-fill">
                <div className='image-container'>
                  <CardImg top src={BrowserWindows} alt="API logo" />
                </div>
                <CardBody className="card-inner pt-0">
                  <CardTitle tag="h5" className='text-xl text-purple-900 font-bold'>Felloh Payment Portal</CardTitle>

                  <CardText>Host a payment portal on your domain, allowing customers to pay for their bookings themselves.</CardText>

                </CardBody>
                <CardFooter>
                    <Row>

                      <Col sm="12" lg="6">
                        <Link to='/organisation/portal'>
                          <Button className='btn-primary btn-block w-100 text-center'>
                            <Icon name="setting" />Manage
                          </Button>
                        </Link>
                      </Col>

                      <Col sm="12" lg="6">
                        <a href='https://developers.felloh.com' target='__blank'>
                          <Button className='btn-secondary btn-block w-100 text-center'>
                            <Icon name="setting" />Documentation
                          </Button>
                        </a>
                      </Col>

                    </Row>

                </CardFooter>
              </Card>
            </Col>

            <Col md="12" lg="3" xl="3" className='d-flex'>
              <Card className="card-bordered integration-item flex-fill">
                <div className='image-container'>
                  <CardImg top src={SlackLogo} alt="Xapier logo" />
                </div>
                <CardBody className="card-inner pt-0">
                  <CardTitle tag="h5" className='text-xl text-purple-900 font-bold'>Slack</CardTitle>

                  <CardText>Receive payments & disbursement notifications to slack</CardText>


                </CardBody>
                <CardFooter>
                  <Button className='btn-green btn-block w-100 text-center' disabled>
                    Coming Soon
                  </Button>
                </CardFooter>
              </Card>
            </Col>

            <Col md="12" lg="3" xl="3" className='d-flex'>
              <Card className="card-bordered integration-item flex-fill">
                <div className='image-container'>
                  <CardImg top src={WebhooksLogo} alt="Webhooks logo" />
                </div>
                <CardBody className="card-inner pt-0">
                  <CardTitle tag="h5" className='text-xl text-purple-900 font-bold'>Webhooks</CardTitle>

                  <CardText>Receive webhooks when changes happen within the felloh ecosystem</CardText>


                </CardBody>
                <CardFooter>
                  {HasRole(account, ['developers:manage:webhooks']) && HasFeature(features, ['developers']) && (
                    <Row>
                      <Col sm="12" lg="6">
                        <Link to='/developers'>
                          <Button className='btn-primary btn-block w-100 text-center'>
                            <Icon name="setting" />Manage
                          </Button>
                        </Link>
                      </Col>

                      <Col sm="12" lg="6">
                        <a href='https://developers.felloh.com/webhooks' target='__blank'>
                          <Button className='btn-secondary btn-block w-100 text-center'>
                            <Icon name="setting" />Documentation
                          </Button>
                        </a>
                      </Col>
                    </Row>
                  )}

                  {(!HasFeature(features, ['developers']) || !HasRole(account, ['developers:manage:webhooks'])) && (
                    <Button className='disabled:bg-red-800 disabled:border-red-800 btn-block w-100 text-center' disabled>
                      You do not have access to this feature
                    </Button>
                  )}
                </CardFooter>
              </Card>
            </Col>

            <Col md="12" lg="3" xl="3" className='d-flex'>
              <Card className="card-bordered integration-item flex-fill">
                <div className='image-container'>
                  <CardImg top src={ZapierLogo} alt="Xapier logo" />
                </div>
                <CardBody className="card-inner pt-0">
                  <CardTitle tag="h5" className='text-xl text-purple-900 font-bold'>Zapier</CardTitle>

                  <CardText>Integrate payments, customer and disbursement data with a wide range of technology providers</CardText>


                </CardBody>
                <CardFooter>
                  <Button className='btn-green btn-block w-100 text-center' disabled>
                    Coming Soon
                  </Button>
                </CardFooter>
              </Card>
            </Col>

          </Row>
        </Col>
      </Row>

    </React.Fragment>
  );
};

export default Integrations;
